import { formatFileSize } from '../../vite/src/utils/filesize.js';

App.namespace('messenger.ListItem', () => {
  /**
     * @param {object} file_details
     * @param {jQuery} $node
     * @param {jQuery} $container
     * @returns {jQuery}
     * @private
     */
  const _appendItemToContainer = function (file_details, $node, $container) {
    $node.attr('data-id', file_details.id);

    setTimeout(() => {
      $node.appendTo($container);
    }, 0);

    return $node;
  };

  const Item = function (file_details, $container, entity) {
    this.file_details = file_details;
    this.entity = entity;
    this.manager = null;
    const size = formatFileSize(file_details.size);
    const content = '' +
          `<div class="uploader-file-list__item" title="${file_details.original_name}"> ` +
                '<i class="uploader-file-list__icon" aria-hidden="true"></i>' +
                `<a class="item-link uploader-file-list__link" target="_blank" href="${file_details.url}"> ${file_details.original_name}</a> ` +
                `<span class="uploader-file-list__filesize">(${size})</span>` +
                '<i class="uploader-file-list__close js-remove-item" aria-hidden="true"></i>' +
              '</span>' +
          '</div>';
    let tem = $.parseHTML(content);
    tem = $(tem);
    this.$node = _appendItemToContainer(file_details, tem, $container);
  };

  Item.prototype.attachEvents = function () {
    const self = this;

    this.$node.find('.js-remove-item')
      .on('click', function (e) {
        e.stopPropagation();
        e.preventDefault();

        const $this = $(this).addClass('disabled');

        if ($this.attr('data-delete')) {
          return false;
        }

        $this.attr('data-delete', 'true');
        self.manager.setReloadOnComplete();
        self.manager.deleteItem(self);
      });

    // if uploaded file is image use magnific popup otherwise open in new tab
    if (['jpg', 'jpeg', 'png', 'bmp'].indexOf(this.file_details.extension) > -1) {
      this.$node.find('a.item-link').magnificPopup({
        mainClass: 'mfp-attachment-preview',
        fixedContentPos: true,
        overflowY: 'hidden',
        type: 'image',
        items: {
          src: this.file_details.url,
        },
        closeBtnInside: false,
        gallery: {
          enabled: true,
          tCounter: '',
        },
        image: {
          cursor: null,
        },
      });
    }
  };

  /**
     * @param {App.messenger.UploadManager} manager
     */
  Item.prototype.setManager = function (manager) {
    this.manager = manager;
  };

  /**
     * @returns {jQuery}
     */
  Item.prototype.getNode = function () {
    return this.$node;
  };

  /**
     * @returns integer
     */
  Item.prototype.getId = function () {
    return this.file_details.id;
  };

  return Item;
});
